<template>
  <FinancialsOverviewCard
    title="Debt Monthly Payment"
    data-testid="debt-monthly-payment-widget"
  >
    <template #default>
      <div class="d-flex align-center text-truncate flex-wrap">
        <h4 class="text-h4 mr-3">{{ monthlyPayment }}/month</h4>
        <SoStatus
          v-if="paymentDayFormatted"
          :status="{ type: 'neutral', text: paymentDayFormatted }"
        />
      </div>
    </template>
    <template #details>
      <SoTooltip
        text="3rd Party Payment Plans cannot be cancelled"
        :disabled="!debtPaymentPlan?.data?.isDDRA"
      >
        <SoButton
          title="Cancel Payment Plan"
          type="danger"
          data-testid="cancel-payment-plan-flow"
          class="mt-2"
          :disabled="debtPaymentPlan?.data?.isDDRA"
          @click="showCancelPaymentPlanModal = true"
        />
      </SoTooltip>
    </template>
  </FinancialsOverviewCard>
  <CancelPaymentPlanModal v-model="showCancelPaymentPlanModal" />
</template>

<script lang="ts">
  import SoStatus from "@/components/SoStatus.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import { formatDay } from "@/helpers/dateHelper"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { defineComponent } from "vue"
  import FinancialsOverviewCard from "../../components/FinancialsOverviewCard.vue"
  import CancelPaymentPlanModal from "../../modals/CancelPaymentPlanModal.vue"

  export default defineComponent({
    components: {
      FinancialsOverviewCard,
      SoStatus,
      SoButton,
      SoTooltip,
      CancelPaymentPlanModal,
    },
    data() {
      return {
        debtPaymentPlan: useCurrentAccountStore().activeDebtPaymentPlan,
        showCancelPaymentPlanModal: false,
      }
    },
    computed: {
      paymentDayFormatted() {
        const day = this.debtPaymentPlan?.data?.paymentDay
        if (!day) return
        return formatDay(day) + " of month"
      },
      monthlyPayment() {
        const amount = this.debtPaymentPlan?.data?.debtMonthlyPayment
        if (!amount) return
        return formatMoney({ amount })
      },
    },
  })
</script>
